// extracted by mini-css-extract-plugin
export default {"customButton":"styles_customButton__WtbO9","bounce":"styles_bounce__aTSpU","sentButton":"styles_sentButton__6NVcp"};